module.exports = __webpack_public_path__ + "img/diagnosis.7bd19cc6.svg";